import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: '#fff',
    position:'relative',
    textAlign:'center'
  },
}));

function CircularProgressWithBackdrop({ open }) {
  const classes = useStyles();

  return (
    <Box className={classes.backdrop} open={open}>
      <CircularProgress color="primary" />
    </Box>
  );
}

export default CircularProgressWithBackdrop;
